import ToSearchButton from "../Common/ToSearchButton";

function Two({ page, text }) {
    return (
        <div className="twopages-container">
            <div className="row">
                <div className="col twos-title-container">
                    <h1 className="text-center comatsu">DE NIEUWBOUW VAN UW DROMEN ZIT HIER ZEKER BIJ</h1>
                    <hr className="underline-title" />
                </div>
            </div>
            <div className="row img-cols no-gutters justify-content-center">
                <div className="col-12 col-md-4 mr-0 pulpula">
                    <div className="img-container img-cont-1 d-flex align-items-end" style={{ backgroundImage: `url("/Images/infopages/${page}/two/1.jpg")` }}>
                        <div>
                            <h2 className="image-dis ml-5 mt-3"> {(text != undefined) && text[page]?.two?.one?.title} </h2>
                            <h5 className="image-dis ml-5">{(text != undefined) && text[page]?.two?.one?.info}</h5>
                            {/* <h5 className="image-dis ml-5 pb-3">vraag nu uw korting</h5> */}
                            <br />
                        </div>
                    </div>

                </div>
                <div className="col-12 col-md-4">
                    <div className="img-container img-cont-2 ml-0 d-flex align-items-end" style={{ backgroundImage: `url("/Images/infopages/${page}/two/2.jpg")` }}>
                        <div>
                            <h2 className="image-dis ml-5 mt-3">{(text != undefined) && text[page]?.two?.two?.title}</h2>
                            <h5 className="image-dis ml-5">{(text != undefined) && text[page]?.two?.two?.info}</h5>
                            {/* <h5 className="image-dis ml-5 pb-3">vraag nu uw korting</h5> */}
                            <br />
                        </div>
                    </div>

                </div>
                <div className="col-12 col-md-2 d-flex align-items-end">
                    <ToSearchButton white/>
                </div>
            </div>
        </div>
    );
}

export default Two;